import { PayloadAction } from '@reduxjs/toolkit';
import { IRootState } from './types';

const reducers = {
  setMembers: (state: IRootState, action: PayloadAction<IRootState['members']>) => ({
    ...state,
    members: action.payload,
  }),
  toggleDeleteDialog: (state: IRootState, action: PayloadAction<IRootState['isOpenDeleteDialog']>) => ({
    ...state,
    isOpenDeleteDialog: action.payload,
  }),
  setSelectedMember: (state: IRootState, action: PayloadAction<IRootState['selectedMember']>) => ({
    ...state,
    selectedMember: action.payload,
  }),
  setIsOpenBulkDialog: (state: IRootState, action: PayloadAction<IRootState['isOpenBulkDialog']>) => ({
    ...state,
    isOpenBulkDialog: action.payload,
  }),
  setShopifyIdToMemberMap: (state: IRootState, action: PayloadAction<IRootState['shopifyIdToMemberMap']>) => ({
    ...state,
    shopifyIdToMemberMap: action.payload,
  }),
  setSelectedLocationId: (state: IRootState, action: PayloadAction<IRootState['selectedLocationId']>) => ({
    ...state,
    selectedLocationId: action.payload,
  }),
  setActiveBulkStep: (state: IRootState, action: PayloadAction<IRootState['activeBulkStep']>) => ({
    ...state,
    activeBulkStep: action.payload,
  }),
  setIsOpenShopifyIdVideo: (state: IRootState, action: PayloadAction<IRootState['isOpenShopifyIdVideo']>) => ({
    ...state,
    isOpenShopifyIdVideo: action.payload,
  }),
  setBulkMembers: (state: IRootState, action: PayloadAction<IRootState['bulkMembers']>) => ({
    ...state,
    bulkMembers: action.payload,
  }),
};

export {
  reducers,
};
